
const message = {
    state:{
        messageCount:0
    },
    mutations:{
        changeMessageCount(state,params){
            state.messageCount = params
        }
    }
}
export default message